// extracted by mini-css-extract-plugin
export var hidden = "_tk-0";